import React from 'react';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import { MY_DAY_CONTENT_ENTRY_ROUTE } from '../../services/routes';
import NarrowEndUserContentEntryCard from './narrow_end_user_content_entry_card';
import { handleClickContentCard } from '../../services/content_entries';
import {
  trackContentClick,
  useTracker,
} from '../../operations/tracking_operations';
import {
  useGetContentEntryByIDAndParentQuery,
  useGetSharedContentEntryByIDAndParentQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const EndUserContentEntryItem = ({ contentEntryID, parentID }) => {
  const navigate = useNavigate();

  const tracker = useTracker();

  const { data: userProfile } = useGetUserProfileQuery();

  const { data: ownContentEntry } = useGetContentEntryByIDAndParentQuery(
    { id: contentEntryID, parentID },
    { skip: !contentEntryID || !parentID },
  );

  const { data: sharedContentEntry } =
    useGetSharedContentEntryByIDAndParentQuery(
      { id: contentEntryID, parentID },
      { skip: !contentEntryID || !parentID },
    );

  const contentEntry = ownContentEntry || sharedContentEntry;

  const contentEntryExists = !!contentEntry;

  const title = contentEntry?.title;

  const coverImageUrl = contentEntry?.coverImageUrl;

  const appLink = contentEntry?.appLink;

  if (!contentEntryExists) {
    return null;
  }

  const onClick = () =>
    handleClickContentCard(
      appLink,
      (hyperlink) => {
        trackContentClick(
          tracker,
          userProfile,
          contentEntryID,
          title,
          hyperlink,
          'My Day',
        );
      },
      navigate,
      () => {
        navigate(
          formatRoute(MY_DAY_CONTENT_ENTRY_ROUTE, {
            parentID,
            sharedContentEntryID: contentEntryID,
          }),
        );
      },
    );

  return (
    <NarrowEndUserContentEntryCard
      title={title}
      coverImageUrl={coverImageUrl}
      onClick={onClick}
    />
  );
};

EndUserContentEntryItem.propTypes = {
  contentEntryID: PropTypes.string.isRequired,
  parentID: PropTypes.string.isRequired,
};

export default EndUserContentEntryItem;
